import React, {

  useEffect,

  useState

} from "react";

import "./Toolbar.css";

import ToolButton from "./ToolButton";
import StyledSelect from "../StyledSelect";



import {

LuBold,

LuItalic,

LuUnderline,

LuHeading1,

LuHeading2,

LuList,

LuListOrdered,

LuQuote,

LuLink,

LuAlignLeft,

LuAlignCenter,

LuAlignRight,

LuAlignJustify,

LuUndo2,

LuRedo2,

LuHighlighter,

LuImage,

LuMessageSquareText,



} from "react-icons/lu";



import {

  API_URL

} from "../../config/api";



import {

  getSafeRichTextUrl

} from "../../utils/safeUrl";



function Toolbar({ editor }) {

const [fontSize, setFontSize] = useState("16px");
const [textColor, setTextColor] = useState("#000000");



const [tableRows, setTableRows] =

  useState(2);



const [tableColumns, setTableColumns] =

  useState(2);



const [shapeType, setShapeType] =

  useState("rectangle");



const [

  openToolbarPanel,

  setOpenToolbarPanel

] = useState(null);



const [

  shapeSettings,

  setShapeSettings

] = useState({

  fillColor: "#f3f4f6",

  strokeColor: "#000000",

  strokeWidth: 2,

  fillOpacity: 100,

  strokeOpacity: 100,

  alignment: "center"

});





useEffect(() => {



  if (!editor) {

    return undefined;

  }



  const syncShapeSettings = () => {



    if (

      !editor.isActive(

        "richTextShape"

      )

    ) {

      return;

    }



    const attributes =

      editor.getAttributes(

        "richTextShape"

      );



    setShapeSettings({

      fillColor:

        attributes.fillColor ||

        "#f3f4f6",



      strokeColor:

        attributes.strokeColor ||

        "#000000",



      strokeWidth:

        Number(

          attributes.strokeWidth ?? 2

        ),



      fillOpacity:

        Number(

          attributes.fillOpacity ?? 100

        ),



      strokeOpacity:

        Number(

          attributes.strokeOpacity ?? 100

        ),



      alignment:

        attributes.alignment ||

        "center"

    });



  };



  editor.on(

    "selectionUpdate",

    syncShapeSettings

  );



  editor.on(

    "update",

    syncShapeSettings

  );



  syncShapeSettings();



  return () => {



    editor.off(

      "selectionUpdate",

      syncShapeSettings

    );



    editor.off(

      "update",

      syncShapeSettings

    );



  };



}, [editor]);





if (!editor) return null;



const addLink = () => {

  const { from, to } = editor.state.selection;



  // No text selected

  if (from === to) {

    alert("Please select some text first, then click the Link button.");

    return;

  }



  const previousUrl = editor.getAttributes("link").href;



  const url = window.prompt("Enter URL", previousUrl || "https://");



  if (url === "") {



  editor

    .chain()

    .focus()

    .unsetLink()

    .run();



  return;



}





const safeUrl =

  getSafeRichTextUrl(url);





if (!safeUrl) {



  alert(

    "Unsafe or invalid link. Use http://, https://, mailto:, tel:, an internal /path, or a #section link."

  );



  return;



}





editor

  .chain()

  .focus()

  .setLink({

    href: safeUrl

  })

  .run();

};



const addImage = async () => {

  const input = document.createElement("input");

  input.type = "file";

  input.accept = "image/*";



  input.onchange = async () => {

    const file = input.files[0];



if (!file) return;



const MAX_IMAGE_SIZE =

  3 * 1024 * 1024;



if (file.size > MAX_IMAGE_SIZE) {



  alert(

    `Image size is ${(file.size / 1024 / 1024).toFixed(2)} MB. Maximum allowed size is 3 MB.`

  );



  return;

}



try {

      const formData = new FormData();

      formData.append("image", file);



      const token =

        localStorage.getItem("adminToken");



      const response = await fetch(

        `${API_URL}/api/editor/upload-image`,

        {

          method: "POST",



          headers: token

            ? {

                Authorization:

                  `Bearer ${token}`,

              }

            : {},



          body: formData,

        }

      );



      const data = await response.json();



      if (data.url) {

        editor

        .chain()

        .focus()

        .insertContent([

          {

            type: "image",

            attrs: {

              src: data.url,

              alt: ""

            }

          },

          {

            type: "paragraph",

            attrs: {

              textAlign: "center"

            },

            content: [

              {

                type: "text",

                marks: [

                  {

                    type: "italic"

                  }

                ],

                text:

                  "Write image caption here..."

              }

            ]

          },

          {

            type: "paragraph"

          }

        ])

      .run();

      } else {

        alert("Image upload failed");

      }

    } catch (error) {

      console.error(error);

      alert("Error uploading image");

    }

  };



  input.click();

};



const alignImage = (alignment) => {

  const { state } = editor;

  const node = state.selection.node;



  if (node && node.type.name === "image") {

    editor.commands.updateAttributes("image", {

      align: alignment,

    });

  } else {

    alert("Please click on an image first.");

  }

};



const resizeImage = (width) => {

  const { state } = editor;

  const node = state.selection.node;



  if (node && node.type.name === "image") {

    editor.commands.updateAttributes("image", {

      width,

    });

  } else {

    alert("Please click on an image first.");

  }

};



const updateSelectedShape = (

  attributes

) => {



  if (

    !editor.isActive(

      "richTextShape"

    )

  ) {



    alert(

      "Click inside a shape before changing its appearance."

    );



    return false;



  }



  const updated =

    editor

      .chain()

      .focus()

      .updateAttributes(

        "richTextShape",

        attributes

      )

      .run();



  if (updated) {



    setShapeSettings(

      (currentSettings) => ({

        ...currentSettings,

        ...attributes

      })

    );



  }



  return updated;



};





const deleteSelectedShape = () => {



  if (

    !editor.isActive(

      "richTextShape"

    )

  ) {



    alert(

      "Click inside a shape before deleting it."

    );



    return;



  }



  editor

    .chain()

    .focus()

    .deleteNode(

      "richTextShape"

    )

    .run();



};





const insertShape = () => {



  editor

    .chain()

    .focus()

    .insertRichTextShape({

      shapeType

    })

    .run();



};





const insertCustomTable = () => {



  const rows =

    Number(tableRows);



  const columns =

    Number(tableColumns);



  if (

    !Number.isInteger(rows) ||

    rows < 1 ||

    rows > 20

  ) {



    alert(

      "Enter a row count between 1 and 20."

    );



    return;

  }



  if (

    !Number.isInteger(columns) ||

    columns < 1 ||

    columns > 10

  ) {



    alert(

      "Enter a column count between 1 and 10."

    );



    return;

  }



  editor

    .chain()

    .focus()

    .insertTable({

      rows,

      cols: columns,

      withHeaderRow: false

    })

    .run();



};





const setTableBorderWidth = (borderWidth) => {



  editor

    .chain()

    .focus()

    .updateAttributes(

      "table",

      {

        borderWidth

      }

    )

    .run();



};





const runTableAction = (action) => {



  if (!action) {

    return;

  }



  if (!editor.isActive("table")) {



    alert(

      "Click inside a table before using this action."

    );



    return;

  }



  const actions = {



    addRowBefore: () =>

      editor

        .chain()

        .focus()

        .addRowBefore()

        .run(),



    addRowAfter: () =>

      editor

        .chain()

        .focus()

        .addRowAfter()

        .run(),



    deleteRow: () =>

      editor

        .chain()

        .focus()

        .deleteRow()

        .run(),



    addColumnBefore: () =>

      editor

        .chain()

        .focus()

        .addColumnBefore()

        .run(),



    addColumnAfter: () =>

      editor

        .chain()

        .focus()

        .addColumnAfter()

        .run(),



    deleteColumn: () =>

      editor

        .chain()

        .focus()

        .deleteColumn()

        .run(),



    mergeCells: () =>

      editor

        .chain()

        .focus()

        .mergeCells()

        .run(),



    splitCell: () =>

      editor

        .chain()

        .focus()

        .splitCell()

        .run(),



    toggleHeaderRow: () =>

      editor

        .chain()

        .focus()

        .toggleHeaderRow()

        .run(),



    toggleHeaderColumn: () =>

      editor

        .chain()

        .focus()

        .toggleHeaderColumn()

        .run(),



    toggleHeaderCell: () =>

      editor

        .chain()

        .focus()

        .toggleHeaderCell()

        .run(),



    borderWidth1: () =>

      setTableBorderWidth(1),



    borderWidth2: () =>

      setTableBorderWidth(2),



    borderWidth3: () =>

      setTableBorderWidth(3),



    borderWidth4: () =>

      setTableBorderWidth(4),



    borderWidth5: () =>

      setTableBorderWidth(5),



    toggleBorders: () => {



      const borderless =

        editor

          .getAttributes("table")

          .borderless === true;



      editor

        .chain()

        .focus()

        .updateAttributes(

          "table",

          {

            borderless:

              !borderless

          }

        )

        .run();



    },



    deleteTable: () =>

      editor

        .chain()

        .focus()

        .deleteTable()

        .run()



  };



  const selectedAction =

    actions[action];



  if (selectedAction) {

    selectedAction();

  }



};



return ( <div className="toolbar">

{/* Headings */}

<ToolButton

icon={<LuHeading1 />}

title="Heading 1"

active={editor.isActive("heading", { level: 1 })}

onClick={() =>

editor.chain().focus().toggleHeading({ level: 1 }).run()

}

/>



  <ToolButton

    icon={<LuHeading2 />}

    title="Heading 2"

    active={editor.isActive("heading", { level: 2 })}

    onClick={() =>

      editor.chain().focus().toggleHeading({ level: 2 }).run()

    }

  />



    <StyledSelect
      value={fontSize}
      ariaLabel="Font size"
      title="Font Size"
      className="styled-select--toolbar styled-select--toolbar-font"
      options={[
        { value: "10px", label: "10" },
        { value: "12px", label: "12" },
        { value: "14px", label: "14" },
        { value: "16px", label: "16" },
        { value: "18px", label: "18" },
        { value: "20px", label: "20" },
        { value: "22px", label: "22" },
        { value: "24px", label: "24" },
        { value: "28px", label: "28" },
        { value: "32px", label: "32" },
        { value: "36px", label: "36" },
        { value: "48px", label: "48" },
        { value: "72px", label: "72" }
      ]}
      onChange={(e) => {

        const size = e.target.value;

        setFontSize(size);

        editor
          .chain()
          .focus()
          .setFontSize(size)
          .run();

      }}
    />



  <StyledSelect
      value={textColor}
      ariaLabel="Text colour"
      title="Text Colour"
      className="styled-select--toolbar styled-select--toolbar-color"
      options={[
        { value: "#000000", label: "Black" },
        { value: "#ff0000", label: "Red" },
        { value: "#0066ff", label: "Blue" },
        { value: "#008000", label: "Green" },
        { value: "#ff8800", label: "Orange" },
        { value: "#800080", label: "Purple" },
        { value: "#666666", label: "Grey" }
      ]}
      onChange={(e) => {

        const color = e.target.value;

        setTextColor(color);

        editor
          .chain()
          .focus()
          .setColor(color)
          .run();

      }}
    />



  {/* Basic formatting */}

  <ToolButton

    icon={<LuBold />}

    title="Bold"

    active={editor.isActive("bold")}

    onClick={() => editor.chain().focus().toggleBold().run()}

  />



  <ToolButton

    icon={<LuItalic />}

    title="Italic"

    active={editor.isActive("italic")}

    onClick={() => editor.chain().focus().toggleItalic().run()}

  />



  <ToolButton

    icon={<LuUnderline />}

    title="Underline"

    active={editor.isActive("underline")}

    onClick={() => editor.chain().focus().toggleUnderline().run()}

  />



    <div

    style={{

      display: "flex",

      alignItems: "center",

      gap: "5px"

    }}

  >



    <LuHighlighter

      title="Highlight Colour"

      style={{

        fontSize: "18px"

      }}

    />



    <StyledSelect
      value=""
      placeholder="Highlight"
      ariaLabel="Highlight colour"
      title="Highlight Colour"
      className="styled-select--toolbar styled-select--toolbar-highlight"
      options={[
        { value: "#fff59d", label: "Yellow" },
        { value: "#ff6767", label: "Red" },
        { value: "#c8e6c9", label: "Green" },
        { value: "#bbdefb", label: "Blue" },
        { value: "#f8bbd0", label: "Pink" },
        { value: "#ffe0b2", label: "Orange" },
        { value: "#e1bee7", label: "Purple" },
        { value: "#e0e0e0", label: "Grey" },
        { value: "remove", label: "Remove Highlight" }
      ]}
      onChange={(e) => {

        const color = e.target.value;

        if (color === "remove") {

          editor
            .chain()
            .focus()
            .unsetHighlight()
            .run();

        } else if (color) {

          editor
            .chain()
            .focus()
            .setHighlight({
              color
            })
            .run();

        }

      }}
    />



  </div>



    <ToolButton



    icon={

      <span

        style={{

          fontFamily: "Georgia, serif",

          fontSize: "20px",

          fontWeight: "bold"

        }}

      >

        A

      </span>

    }



    title="Drop Cap"



    active={

      editor.isActive("paragraph") &&

      editor.getAttributes("paragraph").dropCap === true

    }



    onClick={() => {



      if (!editor.isActive("paragraph")) {



        alert(

          "Place the cursor inside a paragraph to apply Drop Cap."

        );



        return;



      }



      editor

        .chain()

        .focus()

        .toggleDropCap()

        .run();



    }}



  />



  {/* Lists */}

  <ToolButton

    icon={<LuList />}

    title="Bullet List"

    active={editor.isActive("bulletList")}

    onClick={() => editor.chain().focus().toggleBulletList().run()}

  />



  <ToolButton

    icon={<LuListOrdered />}

    title="Numbered List"

    active={editor.isActive("orderedList")}

    onClick={() => editor.chain().focus().toggleOrderedList().run()}

  />



  {/* Quote */}

  <ToolButton

    icon={<LuQuote />}

    title="Blockquote"

    active={editor.isActive("blockquote")}

    onClick={() => editor.chain().focus().toggleBlockquote().run()}

  />



  {/* Link */}

  <ToolButton

    icon={<LuLink />}

    title="Insert Link"

    active={editor.isActive("link")}

    onClick={addLink}

  />



  <ToolButton

    icon={<LuImage />}

    title="Insert Image"

    onClick={addImage}

  />



      {/* SHAPE AND TABLE MENU BUTTONS */}



  <div className="toolbar-panel-buttons">



    <button

      type="button"

      className={

        openToolbarPanel === "shapes"

          ? "toolbar-panel-toggle active"

          : "toolbar-panel-toggle"

      }

      aria-expanded={

        openToolbarPanel === "shapes"

      }

      onClick={() =>

        setOpenToolbarPanel(

          (currentPanel) =>

            currentPanel === "shapes"

              ? null

              : "shapes"

        )

      }

    >

      {openToolbarPanel === "shapes"

        ? "Shapes ▴"

        : "Shapes ▾"}

    </button>



    <button

      type="button"

      className={

        openToolbarPanel === "tables"

          ? "toolbar-panel-toggle active"

          : "toolbar-panel-toggle"

      }

      aria-expanded={

        openToolbarPanel === "tables"

      }

      onClick={() =>

        setOpenToolbarPanel(

          (currentPanel) =>

            currentPanel === "tables"

              ? null

              : "tables"

        )

      }

    >

      {openToolbarPanel === "tables"

        ? "Tables ▴"

        : "Tables ▾"}

    </button>



  </div>





  {/* SHAPE CONTROLS */}



  {openToolbarPanel === "shapes" && (



    <div className="shape-toolbar-section">



    <span className="shape-toolbar-title">

      Shape

    </span>



    <StyledSelect
      value={shapeType}
      ariaLabel="Choose shape"
      title="Choose Shape"
      className="styled-select--toolbar styled-select--shape-type"
      options={[
        { value: "rectangle", label: "Rectangle" },
        { value: "circle", label: "Circle" },
        { value: "oval", label: "Oval" },
        { value: "arrow", label: "Arrow" }
      ]}
      onChange={(event) =>
        setShapeType(
          event.target.value
        )
      }
    />



    <button

      type="button"

      className="shape-insert-button"

      onClick={insertShape}

    >

      Insert Shape

    </button>





    <span

      className="shape-toolbar-divider"

    />





    <span className="shape-format-title">

      Selected Shape

    </span>





    <label

      className="shape-format-control"

      title="Shape Fill Colour"

    >

      <span>Fill</span>



      <input

        className="shape-color-input"

        type="color"

        value={

          shapeSettings.fillColor

        }

        onChange={(event) =>

          updateSelectedShape({

            fillColor:

              event.target.value

          })

        }

      />

    </label>





    <label

      className="shape-format-control"

      title="Shape Edge Colour"

    >

      <span>Edge</span>



      <input

        className="shape-color-input"

        type="color"

        value={

          shapeSettings.strokeColor

        }

        onChange={(event) =>

          updateSelectedShape({

            strokeColor:

              event.target.value

          })

        }

      />

    </label>





    <label

      className="shape-format-control"

      title="Shape Edge Thickness"

    >

      <span>Edge width</span>



      <StyledSelect
          value={shapeSettings.strokeWidth}
          ariaLabel="Shape edge thickness"
          className="styled-select--toolbar styled-select--shape-format"
          options={[
            { value: "1", label: "1 px" },
            { value: "2", label: "2 px" },
            { value: "3", label: "3 px" },
            { value: "4", label: "4 px" },
            { value: "5", label: "5 px" }
          ]}
          onChange={(event) =>
            updateSelectedShape({
              strokeWidth:
                Number(
                  event.target.value
                )
            })
          }
        />

    </label>





    <label

      className="shape-transparency-control"

      title="Shape Fill Transparency"

    >

      <span>Fill transparency</span>



      <input

        className="shape-transparency-range"

        type="range"

        min="0"

        max="100"

        step="5"

        value={

          100 -

          shapeSettings.fillOpacity

        }

        onChange={(event) =>

          updateSelectedShape({

            fillOpacity:

              100 -

              Number(

                event.target.value

              )

          })

        }

      />



      <span className="shape-range-value">

        {100 -

          shapeSettings.fillOpacity}%

      </span>

    </label>





    <label

      className="shape-transparency-control"

      title="Shape Edge Transparency"

    >

      <span>Edge transparency</span>



      <input

        className="shape-transparency-range"

        type="range"

        min="0"

        max="100"

        step="5"

        value={

          100 -

          shapeSettings.strokeOpacity

        }

        onChange={(event) =>

          updateSelectedShape({

            strokeOpacity:

              100 -

              Number(

                event.target.value

              )

          })

        }

      />



      <span className="shape-range-value">

        {100 -

          shapeSettings.strokeOpacity}%

      </span>

    </label>





    <label

      className="shape-format-control"

      title="Shape Alignment"

    >

      <span>Align</span>



      <StyledSelect
          value={shapeSettings.alignment}
          ariaLabel="Shape alignment"
          className="styled-select--toolbar styled-select--shape-align"
          options={[
            { value: "left", label: "Left" },
            { value: "center", label: "Centre" },
            { value: "right", label: "Right" }
          ]}
          onChange={(event) =>
            updateSelectedShape({
              alignment:
                event.target.value
            })
          }
        />

    </label>





    <button

      type="button"

      className="shape-delete-button"

      onClick={deleteSelectedShape}

    >

      Delete Shape

    </button>



      </div>



  )}





  {/* TABLE CONTROLS */}



  {openToolbarPanel === "tables" && (



    <div className="table-toolbar-section">



    <span className="table-toolbar-title">

      Table

    </span>



    <label className="table-size-label">

      Rows



      <input

        className="table-size-input"

        type="number"

        min="1"

        max="20"

        value={tableRows}

        onChange={(e) =>

          setTableRows(e.target.value)

        }

        aria-label="Table rows"

      />

    </label>



    <label className="table-size-label">

      Columns



      <input

        className="table-size-input"

        type="number"

        min="1"

        max="10"

        value={tableColumns}

        onChange={(e) =>

          setTableColumns(e.target.value)

        }

        aria-label="Table columns"

      />

    </label>



    <button

      type="button"

      className="table-insert-button"

      onClick={insertCustomTable}

    >

      Insert Table

    </button>



    <StyledSelect
      value=""
      placeholder="Table Actions"
      ariaLabel="Table actions"
      title="Table Actions"
      className="styled-select--toolbar styled-select--table-actions"
      options={[
        {
          group: "Rows",
          options: [
            { value: "addRowBefore", label: "Add Row Above" },
            { value: "addRowAfter", label: "Add Row Below" },
            { value: "deleteRow", label: "Delete Current Row" }
          ]
        },
        {
          group: "Columns",
          options: [
            { value: "addColumnBefore", label: "Add Column Left" },
            { value: "addColumnAfter", label: "Add Column Right" },
            { value: "deleteColumn", label: "Delete Current Column" }
          ]
        },
        {
          group: "Cells",
          options: [
            { value: "mergeCells", label: "Merge Selected Cells" },
            { value: "splitCell", label: "Split Current Cell" }
          ]
        },
        {
          group: "Headers",
          options: [
            { value: "toggleHeaderRow", label: "Toggle Header Row" },
            { value: "toggleHeaderColumn", label: "Toggle Header Column" },
            { value: "toggleHeaderCell", label: "Toggle Header Cell" }
          ]
        },
        {
          group: "Appearance",
          options: [
            { value: "borderWidth1", label: "Border: Thin — 1 px" },
            { value: "borderWidth2", label: "Border: Medium — 2 px" },
            { value: "borderWidth3", label: "Border: Thick — 3 px" },
            { value: "borderWidth4", label: "Border: Extra Thick — 4 px" },
            { value: "borderWidth5", label: "Border: Heavy — 5 px" },
            { value: "toggleBorders", label: "Hide / Show Borders" }
          ]
        },
        {
          group: "Table",
          options: [
            { value: "deleteTable", label: "Delete Entire Table" }
          ]
        }
      ]}
      onChange={(e) => {

        runTableAction(
          e.target.value
        );

      }}
    />



      </div>



  )}



  {/* <ToolButton

    icon={<LuPanelLeft />}

    title="Image Left"

    onClick={() => alignImage("left")}

  />



  <ToolButton

    icon={<LuAlignCenter />}

    title="Image Center"

    onClick={() => alignImage("center")}

  />



  <ToolButton

    icon={<LuPanelRight />}

    title="Image Right"

    onClick={() => alignImage("right")}

  />



  <ToolButton

    icon={<span style={{fontSize: 12}}>S</span>}

    title="Small Image"

    onClick={() => resizeImage(150)}

  />



  <ToolButton

    icon={<span style={{fontSize: 14}}>M</span>}

    title="Medium Image"

    onClick={() => resizeImage(300)}

  />



  <ToolButton

    icon={<span style={{fontSize: 16}}>L</span>}

    title="Large Image"

    onClick={() => resizeImage(500)}

  />



  <div className="image-resize-control" style={{

    display: 'flex',

    alignItems: 'center',

    gap: '10px',

    padding: '8px 12px',

    borderLeft: '1px solid #ddd',

    marginLeft: '8px'

  }}>

    <span style={{ fontSize: '12px', color: '#666' }}>Image</span>

    <input

      type="range"

      min="80"

      max="800"

      value={imageWidth}

      onChange={(e) => {

        const width = Number(e.target.value);

        setImageWidth(width);

        resizeImage(width);

      }}

      style={{ width: '120px' }}

    />

    <span style={{ fontSize: '12px', width: '45px' }}>

      {imageWidth}px

    </span>

  </div> */}



  {/* Alignment */}

  <ToolButton

    icon={<LuAlignLeft />}

    title="Align Left"

    active={editor.isActive({ textAlign: "left" })}

    onClick={() => editor.chain().focus().setTextAlign("left").run()}

  />



  <ToolButton

    icon={<LuAlignCenter />}

    title="Align Center"

    active={editor.isActive({ textAlign: "center" })}

    onClick={() => editor.chain().focus().setTextAlign("center").run()}

  />



  <ToolButton

    icon={<LuAlignRight />}

    title="Align Right"

    active={editor.isActive({ textAlign: "right" })}

    onClick={() => editor.chain().focus().setTextAlign("right").run()}

  />



  <ToolButton

    icon={<LuAlignJustify />}

    title="Justify"

    active={editor.isActive({ textAlign: "justify" })}

    onClick={() =>

      editor.chain().focus().setTextAlign("justify").run()

    }

  />



  {/* Undo / Redo */}

  <ToolButton

    icon={<LuUndo2 />}

    title="Undo"

    onClick={() => editor.chain().focus().undo().run()}

  />



  <ToolButton

    icon={<LuRedo2 />}

    title="Redo"

    onClick={() => editor.chain().focus().redo().run()}

  />

</div>



);

}



export default Toolbar;
